<template>
  <div class="flex justify-end gap-2">
    <a-button type="primary" @click="downloadPdf" style="border-radius: 3px !important;">Download Pdf</a-button>
    <a-button type="primary" ghost @click="closeReport" style="border-radius: 3px !important;">Close</a-button>
  </div>
</template>

<script>
export default {
  name: "Actions",
  methods: {
    downloadPdf() {
      this.$emit('downloadPdf')
    },
    closeReport() {
      this.$emit('closeReport')
    },
  }
}
</script>

<style scoped>

</style>
